export const defaultNavigationOptions = [
    {
        key: 'home',
        link: '/',
    },
    {
        key: 'biography',
        link: '/biografia',
    },
    {
        key: 'books',
        link: '/libros',
    },
    {
        key: 'paintings',
        link: '/pinturas',
    },
    {
        key: 'blog',
        link: '/blog',
    },
    {
        key: 'contact',
        link: '/contacto',
    },
];